module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{"author":"/people/faye-prince/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/authors-faye-prince.json
// module id = 1589
// module chunks = 2706754912605